import { render } from "./DataProvider.vue?vue&type=template&id=38d8d08a"
import script from "./DataProvider.vue?vue&type=script&lang=js"
export * from "./DataProvider.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__